import { TableProps, Table as AntdTable } from "antd";

import * as Styled from "./styles";

const Table = <T extends object>(props: TableProps<T>) => (
  <Styled.TableWrapper>
    <AntdTable<T> {...props} />
  </Styled.TableWrapper>
);

export default Table;
